export { default as RestaurantMainCard } from './RestaurantMainCard'
